<template>
  <div class="analysisTable">
    <div class="comTitle">
      <h4>{{ title }}</h4>
      <el-button type="primary"
        size="mini"
        plain
        style="margin-right: 20px"
        @click="exportExcel"
        v-if="showDownload"><i class="el-icon-download el-icon--left"></i>EXCEL</el-button>
    </div>
    <el-table :data="tableData"
      border
      stripe
      style="width: 100%"
      :header-cell-style="{
        'font-weight': 'bold',
        color: '#333',
        'background-color': '#F7F7F7',
      }"
      size="small">
      <el-table-column v-for="(v, i) in tabHead"
        :key="i"
        :prop="v.prop"
        :label="v.label"
        :min-width="flexWidth(v.prop,tableData,v.label)"
        align="center"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
import { exportExcelFun, flexWidth } from "@/assets/js/utils";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    tabHead: {
      type: Array,
      default: () => [],
    },
    excelTitle: {
      type: String,
      default: "",
    },
    showDownload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    flexWidth,
    exportExcel() {
      exportFile.xlsxFile(XLSX, this.excelTitle, {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.analysisTable {
  width: $innerWidth;
  margin: 0 auto 16px;
  border-radius: 12px;
  background: #fff;
  padding-bottom: 20px;
  .comTitle {
    @include setFlexBetween;
    height: 42px;
    background-color: #fff;
    h4 {
      font-size: 14px;
      margin: 0 0 0 20px;
      text-indent: 10px;
      color: #5f6b67;
      // border-left: 3px solid #abb2c5;
      border-left: 5px solid #28cccb;
    }
  }
}
</style>